import { render, staticRenderFns } from "./RecordsList.vue?vue&type=template&id=2232ea3c&scoped=true&"
import script from "./RecordsList.vue?vue&type=script&lang=js&"
export * from "./RecordsList.vue?vue&type=script&lang=js&"
import style0 from "./RecordsList.vue?vue&type=style&index=0&id=2232ea3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2232ea3c",
  null
  
)

export default component.exports